import PropTypes from 'prop-types'

import Text from 'components/common/Text'
import TextButton from 'components/common/TextButton'
import Icon from 'components/Icon'
import theme from 'theme'

import { CardMainTitle } from '../ReliabilityScore/ReliabilityScoreCard'

export default function BannerContentWrapper({
  setIsNotificationOpen,
  title,
  collapseIconColor,
  backgroundImage,
  subTitle,
  showContentTitle,
  textColor,
  children,
  canClose,
  contentTitle,
  ...rest
}) {
  const hasCloseAction = canClose && setIsNotificationOpen

  return (
    <div
      css={{
        display: 'grid',
        border: theme.border.base,
        borderRadius: theme.borderRadius[1],
        backgroundColor: theme.colors.white[0],
        padding: theme.space[3],
        paddingBottom: theme.space[4],
        background: backgroundImage
          ? `${theme.colors.white[0]} url(${backgroundImage}) no-repeat 100% ${theme.space[6]}px`
          : theme.colors.steel[2],
        backgroundSize: backgroundImage ? 225 : '100%',
        maxHeight: 250,
        paddingRight: hasCloseAction && theme.space[7],
        overflow: 'auto',
        position: 'relative'
      }}
      data-testid="data-test-next-step-content"
      {...rest}
    >
      {title &&
        (typeof title === 'function' ? (
          title({
            'data-testid': 'dashboard-next-step-header',
            css: {
              marginBottom: subTitle ? theme.space[2] : theme.space[3]
            }
          })
        ) : (
          <Text
            as="h2"
            css={{
              marginBottom: subTitle ? theme.space[2] : theme.space[3],
              color: textColor
            }}
            data-testid="dashboard-next-step-header"
          >
            {title}
          </Text>
        ))}
      {subTitle && (
        <Text
          as="small"
          css={{
            fontSize: theme.fontSizes[1],
            color: textColor
          }}
        >
          {subTitle}
        </Text>
      )}
      {showContentTitle && (
        <CardMainTitle
          css={{
            marginBottom: theme.space[2],
            fontSize: contentTitle ? theme.fontSizes[2] : theme.fontSizes[0]
          }}
        >
          {contentTitle || 'TRY THESE NEXT:'}
        </CardMainTitle>
      )}
      {children}

      {hasCloseAction && (
        <div>
          <TextButton
            secondary
            css={{
              marginLeft: 'auto',
              color: collapseIconColor,
              '&:hover, &:focus, &:active': {
                color: collapseIconColor
              },
              position: 'absolute',
              top: theme.space[3],
              right: theme.space[3]
            }}
            data-testid="close-walkthrough-button"
            onClick={() => setIsNotificationOpen(0)}
          >
            <Icon
              aria-label="close"
              css={{
                width: theme.space[3]
              }}
              icon="close"
            />
          </TextButton>
        </div>
      )}
    </div>
  )
}

BannerContentWrapper.propTypes = {
  setIsNotificationOpen: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  children: PropTypes.node,
  collapseIconColor: PropTypes.string,
  backgroundImage: PropTypes.string,
  showContentTitle: PropTypes.bool,
  subTitle: PropTypes.node,
  textColor: PropTypes.string,
  canClose: PropTypes.bool,
  contentTitle: PropTypes.string
}

BannerContentWrapper.defaultProps = {
  collapseIconColor: theme.colors.steel[2],
  showContentTitle: true,
  textColor: theme.colors.steel[2],
  canClose: true
}
